import api from './api';
import { AuditLog, AuditLogFilter } from '../types/auditLog';

interface PagedResult<T> {
  items: T[];
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  hasPrevious: boolean;
  hasNext: boolean;
}

export const auditLogService = {
  async getAll(filter?: AuditLogFilter): Promise<PagedResult<AuditLog>> {
    const params = new URLSearchParams();

    if (filter?.action) params.append('action', filter.action);
    if (filter?.entityType) params.append('entityType', filter.entityType);
    if (filter?.userEmail) params.append('userEmail', filter.userEmail);
    if (filter?.fromDate) params.append('fromDate', filter.fromDate);
    if (filter?.toDate) params.append('toDate', filter.toDate);
    if (filter?.page) params.append('page', String(filter.page));
    if (filter?.pageSize) params.append('pageSize', String(filter.pageSize));

    const queryString = params.toString();
    const url = queryString ? `/api/v1/audit-logs?${queryString}` : '/api/v1/audit-logs';

    const { data } = await api.get(url);
    return data.data ?? data;
  },
};
